var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBagCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ceb07c",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300.005 300.005",
    style: {
      enableBackground: "new 0 0 300.005 300.005"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182.936,76.966h-0.002c0-18.516-15.066-33.58-33.58-33.58c-18.516,0-33.58,15.064-33.58,33.58v11.671h67.162V76.966z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.585,104.199h-8.09v10.911c2.498,2.179,4.113,5.351,4.113,8.93c0,6.57-5.325,11.897-11.894,11.897 c-6.564,0-11.894-5.327-11.894-11.897c0-3.577,1.611-6.749,4.113-8.927v-10.914h-67.162v10.911c2.5,2.181,4.113,5.351,4.113,8.93 c0,6.57-5.327,11.897-11.894,11.897c-6.57,0-11.894-5.327-11.894-11.897c0-3.577,1.613-6.751,4.113-8.93v-10.911h-8.09 c-4.573,0-8.292,3.719-8.292,8.292v111.168c0,4.573,3.719,8.292,8.292,8.292h114.465c4.57,0,8.292-3.722,8.292-8.292V112.491 C214.877,107.918,211.155,104.199,206.585,104.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,0C67.159,0,0.002,67.162,0.002,150S67.159,300.005,150,300.005S300.003,232.841,300.003,150S232.841,0,150,0z  M230.439,223.659c0,13.152-10.704,23.854-23.854,23.854H92.121c-13.152,0-23.854-10.701-23.854-23.854V112.491 c0-13.152,10.701-23.854,23.854-23.854h8.09V76.966c0-27.098,22.046-49.142,49.142-49.142s49.142,22.046,49.142,49.142v11.671 h8.09c13.15,0,23.854,10.701,23.854,23.854V223.659z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagCircle);
export default __webpack_public_path__ + "static/media/bag-circle.31929092271be35066573483da93def0.svg";
export { ForwardRef as ReactComponent };